import React from 'react'
import { clsx } from 'clsx'
import { useTheme } from '@/contexts/ThemeContext'

interface ThemeControlsProps {
  className?: string
  disabled?: boolean
}

const ThemeControls: React.FC<ThemeControlsProps> = ({ className = '', disabled = false }) => {
  const { fontSize, setFontSize } = useTheme()

  return (
    <div className={clsx('space-y-4', className)}>
      {/* Font Size Control */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-medium text-gray-900">Font Size</h3>
          <p className="text-xs text-gray-500">Adjust text size for comfort</p>
        </div>
        <div className="flex items-center gap-1">
          {(['small', 'medium', 'large'] as const).map((size) => (
            <button
              key={size}
              onClick={() => setFontSize(size)}
              disabled={disabled}
              className={clsx(
                'px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200 capitalize',
                fontSize === size
                  ? 'bg-snwolley-green-100 text-snwolley-green-700 ring-2 ring-snwolley-green-500'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-600',
                disabled && 'opacity-50 cursor-not-allowed'
              )}
            >
              {size}
            </button>
          ))}
        </div>
      </div>

      {/* Preview Text */}
      <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-xs text-gray-500 mb-1">Preview:</p>
        <h3 className="font-semibold text-gray-900 mb-1">Sample Heading</h3>
        <p className="text-gray-700 text-sm">
          This is how text will appear during your interview. Adjust the font size above for optimal readability.
        </p>
      </div>

      {disabled && (
        <div className="text-xs text-amber-600 bg-amber-50 p-2 rounded-lg">
          ⚠️ Font settings cannot be changed during the interview
        </div>
      )}
    </div>
  )
}

export default ThemeControls